import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ModalContainer from '@components/modals/ModalContainer';

import UploadTrendResearchImage from '@features/trend-research/components/common/imageSearch/UploadTrendResearchImage';
import {
	CloseButton,
	ModalBody,
	ModalHeader,
	ModalTitle
} from '@features/trend-research/components/common/Modal';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { saveImageSearchHistory } from '@services/trendResearch';

import { capitalizeFirstLetter } from '@utils/Util';

const ImageSearchModal = ({ onClose, sourceType = 'BRAND' }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const handleSubmit = async (selectedFile) => {
		try {
			dispatch(openLoader());
			await saveImageSearchHistory(selectedFile);
			navigate(`/trends/image-search`, { state: { source: capitalizeFirstLetter(sourceType) } });
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const doFileSelection = async (fileObj) => {
		await handleSubmit(fileObj);
	};

	return (
		<ModalContainer onCloseModal={onClose} className="image-search-modal">
			<div className="common-popup image-search-modal">
				<ModalHeader>
					<ModalTitle title="Image Search" />
					<CloseButton onClick={onClose} />
				</ModalHeader>
				<ModalBody>
					<div className="image-upload">
						<UploadTrendResearchImage
							className="file-uploader large upload-design-image"
							doFileSelection={doFileSelection}
						/>
					</div>
				</ModalBody>
			</div>
		</ModalContainer>
	);
};

export default ImageSearchModal;
